import useCrud from 'hooks/useCrud';
import { fetch, update } from 'services/api/assistant.priority';

function usePriority() {
  return useCrud({
    read: fetch,
    update,
  });
}

export default usePriority;
